// extracted by mini-css-extract-plugin
export default {"primaryBlue":"#00a2d2","primaryLightGrey":"#d1d1d1","full":"Logo_full__BpppI","defaultColor":"Logo_defaultColor__I6Q4z","white":"Logo_white__oX0M1","black":"Logo_black__YtbR5"};